<template lang="pug">
  .user-data
    img.user-data__placeholder(:src="placeholderSrc")
</template>

<script lang="ts">
  import placeholderSrc from './images/placeholder.svg';

  export default defineNuxtComponent({
    name: 'UserDataPlaceholder',

    computed: {
      placeholderSrc: () => placeholderSrc,
    },
  });
</script>

<style lang="scss" scoped>
  .user-data {
    background: white;
  }
  .user-data__placeholder {
    width: 220px;
    height: 440px;
  }
</style>
